import { selector, atom } from "recoil";
import { getFeature, getGramPage } from "../services/apiCalls";

export const featureRefresh = atom({
  key: "featureRefresh",
  default: ""
})

export const gramRefresh = atom({
  key: "gramRefresh",
  default: ""
})

export const featureAlert = atom({
  key: "featureAlert",
  default: false
})

export const featureResponse = atom({
  key: "featureResponse",
  default: {}
})

export const features = selector({
  key: "features",
  get: async ({ get }) => {
    try {
      const res = get(featureRefresh);
      console.log(res)
      const result = await getFeature();
      return result.data || [];
    } catch (error) {
      console.error(`ERROR: \n${error}`);
      return [];
    }
  }
});

export const gramPage = selector({
  key: "gramPage",
  get: async ({ get }) => {
    try {
      const res = get(gramRefresh);
      console.log(res)
      const result = await getGramPage();
      return result || {};
    } catch (error) {
      console.error(`ERROR: \n${error}`);
      return {};
    }
  }
});